module.exports = __webpack_public_path__ + "static/media/alexion-pharma.fda47f5a.jpg";